import * as React from "react";
const SvgManageSearch = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill={props.fill || "currentColor"}
      d="M3 19a.97.97 0 0 1-.712-.288A.97.97 0 0 1 2 18q0-.424.288-.712A.97.97 0 0 1 3 17h8q.424 0 .713.288.287.287.287.712 0 .424-.287.712A.97.97 0 0 1 11 19zm0-5a.97.97 0 0 1-.712-.287A.97.97 0 0 1 2 13q0-.424.288-.713A.97.97 0 0 1 3 12h3q.424 0 .713.287Q7 12.576 7 13q0 .424-.287.713A.97.97 0 0 1 6 14zm0-5a.97.97 0 0 1-.712-.287A.97.97 0 0 1 2 8q0-.424.288-.713A.97.97 0 0 1 3 7h3q.424 0 .713.287Q7 7.576 7 8q0 .424-.287.713A.97.97 0 0 1 6 9zm11 7q-2.075 0-3.537-1.463Q9 13.075 9 11q0-2.075 1.463-3.537Q11.926 6 14 6q2.075 0 3.538 1.463Q19 8.925 19 11q0 .725-.212 1.438a4.5 4.5 0 0 1-.638 1.312l3.15 3.15a.95.95 0 0 1 .275.7.95.95 0 0 1-.275.7.95.95 0 0 1-.7.275.95.95 0 0 1-.7-.275l-3.15-3.15q-.6.425-1.312.637A5 5 0 0 1 14 16m0-2q1.25 0 2.125-.875A2.9 2.9 0 0 0 17 11q0-1.25-.875-2.125A2.9 2.9 0 0 0 14 8q-1.25 0-2.125.875A2.9 2.9 0 0 0 11 11q0 1.25.875 2.125A2.9 2.9 0 0 0 14 14"
    />
  </svg>
);
export default SvgManageSearch;
